/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_QuestionInputs */

const en_us2_onboarding_experience_question = /** @type {(inputs: Onboarding_Experience_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have you trained with weights before?`)
};

const pt_br2_onboarding_experience_question = /** @type {(inputs: Onboarding_Experience_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já treinou com pesos antes?`)
};

const es_419_onboarding_experience_question = /** @type {(inputs: Onboarding_Experience_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Has entrenado con pesas antes?`)
};

const pt_pt2_onboarding_experience_question = /** @type {(inputs: Onboarding_Experience_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já treinaste com pesos antes?`)
};

const fr_fr2_onboarding_experience_question = /** @type {(inputs: Onboarding_Experience_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As-tu déjà fait de la musculation ?`)
};

const de_de2_onboarding_experience_question = /** @type {(inputs: Onboarding_Experience_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du schon mit Gewichten trainiert?`)
};

const it_it2_onboarding_experience_question = /** @type {(inputs: Onboarding_Experience_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già fatto pesi?`)
};

/**
* | output |
* | --- |
* | "Have you trained with weights before?" |
*
* @param {Onboarding_Experience_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_question = /** @type {((inputs?: Onboarding_Experience_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_question(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_question(inputs)
	return en_us2_onboarding_experience_question(inputs)
});
export { onboarding_experience_question as "onboarding.experience.question" }